$.ready(function() {
	game.konami_fallback = {
		'_': 'konami_base_fallback',
		data: base, //-- ../slot/games/konami_chinamystery/
		konami_bell: [17.5, 2.6],
		bell: [17.5, 2.6],
		trigger: [20.2, 1.8],
		reel_start: [22.1, .6],
		reel: [[22.75, .25],[22.75, .25],[22.75, .25],[22.75, .25],[22.75, .25]],
		spin: [.1, .38],
		five_win: [23.1, 5.4],
		freespin : {
			freegames: [28.6, 1.15],
		},
		buttons: {
			spin: [.1, .38],
			button: [12.9, .4],
			auto: [14.15, .15],
			sound: [3.7, .7],
			close: [.55, .5],
			open:  [2.6, .5],
			help: [14.75, .25],
			next: [2.15, .3],
			prev: [3.22, .4],
			max:  [1.15, .85],
			recall: [13.4, .25],
			lobby: [13.8, .25],
			menu: [14.6, .1],
			denom: [14.35, .15],
			autos: {
				auto_0: [15, .38],
				auto_1: [15.5, .3],
				auto_2: [15.9, .3],
				auto_3: [16.3, .3],
				auto_4: [16.7, .3],
				auto_5: [17.1, .3],
			},
			coins: {
				bet_0: [4.5, .3],
				bet_1: [4.9, .25],
				bet_2: [5.3, .3],
				bet_3: [5.7, .2],
				bet_4: [6,   .2],
				bet_5: [6.3, .2],
				bet_6: [6.6, .2],
				bet_7: [6.9, .2],
				bet_8: [7.2, .2],
			},
			denoms: {
				denom_0: [7.5,   .6],
				denom_1: [8.2,   .6],
				denom_2: [8.85,  .57],
				denom_3: [9.5,   .55],
				denom_4: [10.15, .6],
				denom_5: [10.85, .55],
				denom_6: [11.55, .55],
				denom_7: [12.2,  .55],
			}
		},
		win: {
			intro1: [29.8, 2.8],
			intro2: [32.7, 2.1],
			win_1: [34.9, .8],
			win_2: [35.9, 2.3],
			win_3: [39, 3.5],
			bigwin_1: [43, 5.1],
			bigwin_2: [48.3, 11.7],
			bigwin_3: [61.5, 15.8],
			konami_1: [43, 5.1],
			konami_2: [48.3, 11.7],
			konami_3: [61.5, 15.8],
		},
	};
	game.on('ready', function() {
		game.konami_fallback._ = 'konami_base_fallback';
		game.konami_fallback['_'] = 'konami_base_fallback';
		
		if (game.sounds.setFallback) {
			game.sounds.setFallback('..'+base, game.konami_fallback);
			game.sounds.sounds.win = {};
			game.sounds.sounds.drop = [];
			if (!game.sounds.sounds.freespin) {
				game.sounds.sounds.freespin = {};
			}
			game.sounds.sounds.freespin.drop = [];
			game.sounds.sounds.win.konami_1 = game.sounds.fallback.win.bigwin_1;
			game.sounds.sounds.win.konami_2 = game.sounds.fallback.win.bigwin_2;
			game.sounds.sounds.win.konami_3 = game.sounds.fallback.win.bigwin_3;
		}
	});
});



/** WEBPACK FOOTER **
 ** ./public-src/js/konami_fallback.js
 **/